const apiList = [
  {
    Name: 'Anatolian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fabb7a78-b9f1-4ff4-84fd-010e100b39dc',
    Id: 151,
  },
  {
    Name: 'Doberman Pinscher',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'afaf59df-186d-4360-8793-01313745dcc4',
    Id: 202,
  },
  {
    Name: 'Tibetan Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fdd2df4a-b97c-4c42-9ca8-0135eda57acf',
    Id: 298,
  },
  {
    Name: 'Feist',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '95d60080-367f-4ff3-aabe-01f4f30e10cb',
    Id: 426,
  },
  {
    Name: 'Chinese Foo Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '73bb1d47-44df-40ab-94be-027155f19c5c',
    Id: 427,
  },
  {
    Name: 'Shar Pei',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '383379e1-8151-44cf-ba62-02cb10020aae',
    Id: 330,
  },
  {
    Name: 'Chipoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '50e0a13b-d902-4ac3-bf82-03ad7577c4da',
    Id: 400,
  },
  {
    Name: 'Chesapeake Bay Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '52730c87-85d3-48bb-9501-0591de3ac021',
    Id: 188,
  },
  {
    Name: 'Collie - Rough',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6557eaaf-f3c3-49e3-a945-0639ea6daad8',
    Id: 39,
  },
  {
    Name: 'American Foxhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '749313e2-6313-4dcb-b6a8-0825d02d1554',
    Id: 147,
  },
  {
    Name: 'Lagotto Romagnolo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '532a5291-25c8-45a5-9592-08b2a147a3da',
    Id: 77,
  },
  {
    Name: 'Eurasian/Eurasier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c96cce0c-3cb9-45cb-bc65-0969824d5ce2',
    Id: 56,
  },
  {
    Name: 'German Shorthaired Pointer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '83fade20-764d-42c9-8478-09e2e75837cd',
    Id: 215,
  },
  {
    Name: 'Basset Fauve de Bretagne',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e5ff0550-970e-4d52-a7a0-0b6c7a184193',
    Id: 19,
  },
  {
    Name: 'Skye Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3ee49539-2628-4316-a831-0b72d786c802',
    Id: 289,
  },
  {
    Name: 'Petit Basset Griffon Vendeen',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd0d8898b-2831-4ce9-9634-0b7c6f74b1a1',
    Id: 89,
  },
  {
    Name: 'Miniature Smooth Haired Dachshund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '78ebd57e-2be9-4330-b688-0b93f78a25a6',
    Id: 45,
  },
  {
    Name: 'Sheepadoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2787ae39-c5f3-4fff-8894-0c0d8206101b',
    Id: 478,
  },
  {
    Name: 'English Bulldog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'cc77e115-f9d7-4ef4-a5a3-0c8e179c8657',
    Id: 320,
  },
  {
    Name: 'Mixed breed Medium (20 - 55lbs when full grown)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b0d89bf5-66b4-471f-9347-0cd1625931b3',
    Id: 445,
  },
  {
    Name: 'Finnish Lapphund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '46ad1290-f932-41fc-bc58-0cf3a8f5342c',
    Id: 58,
  },
  {
    Name: 'Pudelpointer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '93872241-153e-4650-b7d4-0e0343d9d53f',
    Id: 95,
  },
  {
    Name: 'Curly-Coated Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0a42c36e-6ad1-47a4-8da2-0e0d26172775',
    Id: 198,
  },
  {
    Name: 'Spanish Bulldog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'edd8caa8-bae0-45b4-973b-0e55ba484006',
    Id: 331,
  },
  {
    Name: 'Maremma',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd870545b-4bc4-4408-9811-0e6b4a23c561',
    Id: 81,
  },
  {
    Name: 'Welsh Foxhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c3bfe5f9-61c4-4a27-9b1f-0e6dfb4646d2',
    Id: 438,
  },
  {
    Name: 'Picardy Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '34fc7ebd-7a82-47fa-ae71-0ebf0add1a13',
    Id: 110,
  },
  {
    Name: 'Basenji',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5d802e11-d1c5-4029-ab99-0fad16408b57',
    Id: 155,
  },
  {
    Name: 'Miniature Schnauzer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '190a6f04-942c-4e34-9475-0fe6f2fafdfd',
    Id: 250,
  },
  {
    Name: 'Chinese Crested',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'cb0adef0-9cc5-4639-b4da-10a1d85a3a93',
    Id: 190,
  },
  {
    Name: 'Labrador Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '90fbca7d-4881-4230-942e-10dc09508aaf',
    Id: 239,
  },
  {
    Name: 'Peruvian Inca Orchid',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fee3314a-de03-4c18-9edf-10dd4a85cf26',
    Id: 88,
  },
  {
    Name: 'Broholmer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a79f1243-bd38-4692-ac04-12970965b9a7',
    Id: 442,
  },
  {
    Name: 'Old Victorian Bulldogge',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a47504c4-6609-4dc0-8abd-133e6416eb2b',
    Id: 327,
  },
  {
    Name: 'Akbash Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0325b3ca-021c-4507-b95c-1389f685eeaf',
    Id: 440,
  },
  {
    Name: 'Bassetoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9f7f365f-06a0-473a-a57c-13d1beabb903',
    Id: 460,
  },
  {
    Name: 'Beagle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '22754812-a43e-4847-a531-13f93ed32608',
    Id: 157,
  },
  {
    Name: 'Norfolk Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '305ec17a-bb3f-4632-a2e0-1568f964f0a9',
    Id: 253,
  },
  {
    Name: 'Field Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0099d50e-4219-4652-9262-15e5714e405c',
    Id: 209,
  },
  {
    Name: 'Bearded Collie',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4fb82d25-e7f3-4024-934c-15f48e08b24f',
    Id: 158,
  },
  {
    Name: 'Double Doodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ebc1b9dd-fcb9-48eb-85fd-167272edda9e',
    Id: 480,
  },
  {
    Name: 'Polish Lowland Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '777e2516-eb8f-47e9-8d12-16ef8c83a4a1',
    Id: 267,
  },
  {
    Name: 'Tibetan Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9be9bfe6-c3e0-489a-b9d9-1784f606362a',
    Id: 299,
  },
  {
    Name: 'Icelandic sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '347dd948-3685-47d8-ab14-18229ba23a1f',
    Id: 103,
  },
  {
    Name: 'Portuguese Water Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'bb89a70d-c655-4070-b56e-185fca195b48',
    Id: 94,
  },
  {
    Name: 'Bull Boxer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '21d0365a-8990-4f91-92a3-18cbe0fd90bc',
    Id: 318,
  },
  {
    Name: 'Welsh Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '08316e94-949a-4882-bd38-1908bf9a0a88',
    Id: 304,
  },
  {
    Name: 'Pug',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0897fcc2-64c5-48a3-bce4-19a9b220863d',
    Id: 271,
  },
  {
    Name: 'Spinone Italiano',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a69dd4c0-e434-4ed8-8cd0-1a1246bb29c5',
    Id: 292,
  },
  {
    Name: 'Treeing Walker Coonhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f1c37bc0-9581-451e-9317-1afdf6e94d94',
    Id: 334,
  },
  {
    Name: 'American Staffordshire Bull Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'bbe90da9-4a7c-4072-ab5b-1b394c975818',
    Id: 117,
  },
  {
    Name: 'Chihuahua (Short Coat)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ae49772d-10a2-4122-a50e-1b8367acfc72',
    Id: 37,
  },
  {
    Name: 'New Zealand Huntaway',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c24f919d-277c-4538-b0bb-1b949439af8d',
    Id: 70,
  },
  {
    Name: 'Belgian Malinois',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'eba69a74-6123-4d9b-81c5-1b9ad3ac5378',
    Id: 161,
  },
  {
    Name: 'Danish Swedish Farmdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '45bc6be4-8bdb-4add-8372-1d33eb97c018',
    Id: 487,
  },
  {
    Name: 'German Wirehaired Pointer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3df226a8-fdae-4e53-a0b9-1e7769c51b19',
    Id: 217,
  },
  {
    Name: 'Hamiltonstovare',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '27ca1d93-656e-4469-8138-1f65df83d4bb',
    Id: 66,
  },
  {
    Name: 'Boerboel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd5e93705-3194-47c3-8a12-1fa049c5f423',
    Id: 409,
  },
  {
    Name: 'American Staffordshire Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '29d772af-b11f-43a4-b622-1ff1ca5fe79b',
    Id: 149,
  },
  {
    Name: 'Bantam Bulldog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '563737c8-7f92-4415-afcb-20f811b74f23',
    Id: 484,
  },
  {
    Name: 'Japanese Spitz',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'be7074d3-3538-4035-bd12-2209cad2bc71',
    Id: 73,
  },
  {
    Name: 'Greenland Dog ',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'adbcba07-6a70-4bab-b259-221bf2fbf799',
    Id: 64,
  },
  {
    Name: 'Affenpinscher',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '610321c9-7231-4282-9129-2393343c82f8',
    Id: 141,
  },
  {
    Name: 'Volpino Italiano',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a6ffefa5-69ab-4322-8800-248814a5cb88',
    Id: 424,
  },
  {
    Name: 'English Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'cc92a9ac-a2a8-48e3-8614-25f2167f95d4',
    Id: 82,
  },
  {
    Name: 'Coton de Tulear',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9f7724d5-9cf3-446d-82d5-267de8c5edf3',
    Id: 197,
  },
  {
    Name: 'Bergamasco Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fae094fc-aeb2-4917-8a6a-26e7e5572120',
    Id: 23,
  },
  {
    Name: 'Austrian Grand Brackes',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b5812ff4-436d-4cfe-a0e4-27aada4ee948',
    Id: 431,
  },
  {
    Name: 'Pomapoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '11541a2c-ccb3-4ed1-846b-288a47e6d19b',
    Id: 399,
  },
  {
    Name: 'Australian Silky Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '01f14855-49d6-459a-9821-291f20e6d803',
    Id: 118,
  },
  {
    Name: 'Peekapoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '60fcf28e-eaf8-484c-8934-293c1e5b1b23',
    Id: 474,
  },
  {
    Name: 'Chiweenie',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e16224a0-f85d-44d5-8241-29ba5c7f7c87',
    Id: 483,
  },
  {
    Name: 'Silken Windhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f80328a4-e8be-40b8-b4b4-29fce89a21f3',
    Id: 412,
  },
  {
    Name: 'Goldendoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f908bfbe-a699-4b37-bff5-2cc69c84f000',
    Id: 392,
  },
  {
    Name: 'Olde English Bulldog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '59dc4143-8d3f-4e82-aa75-2dbb1fdeaef5',
    Id: 410,
  },
  {
    Name: 'Kishu Ken',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '669ee37b-e218-4d23-b357-2dfa36c88463',
    Id: 75,
  },
  {
    Name: 'Gordon Setter',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0a530b4b-a4de-44e2-8b32-2f9814d7e245',
    Id: 221,
  },
  {
    Name: 'Native American Indian',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4735ea57-6b14-4507-ab57-2fb04e99f2fa',
    Id: 391,
  },
  {
    Name: 'Spanish Water Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0bf030e3-5688-401e-9901-31215c3dcd00',
    Id: 112,
  },
  {
    Name: 'Schichon/Zuchon',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '22aa00cd-efb4-48e9-8d7f-31793dab47c7',
    Id: 485,
  },
  {
    Name: 'Miniature Long Haired Dachshund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3128f1da-3e80-4d04-9f92-32d1b341ac18',
    Id: 44,
  },
  {
    Name: 'Old Boston Bulldogge',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '32062e8b-2f5e-4a2b-8964-333231af079d',
    Id: 326,
  },
  {
    Name: 'Porkie',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3bb370c1-dd27-4b21-b009-33b4c8ffc04e',
    Id: 402,
  },
  {
    Name: 'Pointer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e272b992-4816-4bb9-b2bf-34d726c34889',
    Id: 266,
  },
  {
    Name: 'Sloughi',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a60328d1-a58f-41e8-9d05-34e25fec5bc1',
    Id: 106,
  },
  {
    Name: 'Alaskan Klee Kai',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7816edf8-b058-4dbd-a832-3528f56b1e31',
    Id: 425,
  },
  {
    Name: 'Pyrenean Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7aa14512-1262-4d63-9e84-356b12588fc5',
    Id: 329,
  },
  {
    Name: 'Bichon Frise',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a4b9cd6d-a275-4dc6-939b-3682068a6930',
    Id: 165,
  },
  {
    Name: 'Afghan Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '38578cec-6511-41fb-9bdd-38c91b99558a',
    Id: 142,
  },
  {
    Name: 'Aussiedoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a1161d89-7e2c-4a39-b9bf-38d5f18d9deb',
    Id: 454,
  },
  {
    Name: 'Chipom',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '83fcff11-8ac3-491a-ba1f-39064fda6e4a',
    Id: 401,
  },
  {
    Name: 'Wire Fox Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6fb4a30c-45b1-44de-8c72-3b48f5cd5036',
    Id: 307,
  },
  {
    Name: 'Smooth Fox Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c668b217-372e-458e-bfa6-3ba4c51d3a2b',
    Id: 290,
  },
  {
    Name: 'Polish Tatra Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '54c7e8b0-1b55-44b8-9dec-3be9d26f94d5',
    Id: 441,
  },
  {
    Name: 'Caucasian Ovcharka',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f7dfa8a6-8da2-437b-9b57-3cc9e9587014',
    Id: 34,
  },
  {
    Name: 'Cavapoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c1de8167-2fdb-48a9-91dc-3d162a9af7bf',
    Id: 464,
  },
  {
    Name: 'Schipperke',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c60ec182-f57a-4747-9561-3e799f3f8193',
    Id: 280,
  },
  {
    Name: 'Saluki (Gazelle Hound)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '445846b2-4163-4c25-9846-3e9da2a312e0',
    Id: 278,
  },
  {
    Name: 'Kooikerhondje',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4a127bf3-d5b7-4e1d-ad76-3eb8a792ae17',
    Id: 76,
  },
  {
    Name: 'Miniature Pinscher',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1651a122-c45a-44f0-8f3f-3f04e3c80fb7',
    Id: 249,
  },
  {
    Name: 'Irish Wolfhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6d815bcb-3009-484d-9cb4-41c24d57465d',
    Id: 232,
  },
  {
    Name: 'Harrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8dbefb74-f2f5-4bc1-98a8-42126c6a63fc',
    Id: 226,
  },
  {
    Name: 'Australian Kelpie',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f363f272-5240-4203-a4ad-43252a25ed04',
    Id: 16,
  },
  {
    Name: 'Estrela Mountain Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ecf244b7-7f8f-48ce-be0b-447c046fdd7f',
    Id: 55,
  },
  {
    Name: 'Pharaoh Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c11e19de-6384-4559-8170-455510944f9b',
    Id: 264,
  },
  {
    Name: 'Bernedoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd45e07db-8a28-4493-a397-4644df25756e',
    Id: 461,
  },
  {
    Name: 'Briard',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '752527d4-4e81-41cd-a608-4669e0c655ec',
    Id: 176,
  },
  {
    Name: 'Groenendael Belgian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fec9a837-0ba8-454b-b7cb-4690ce6cc7f8',
    Id: 22,
  },
  {
    Name: 'Poodle-Miniature',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1786b92d-5719-4ae1-b122-46c9fccbea65',
    Id: 90,
  },
  {
    Name: 'Miniature Australian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6faf01fb-cc08-459e-8236-470723df0c0a',
    Id: 247,
  },
  {
    Name: 'Scottish (Scottie)/Aberdeen Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '685f85c2-fc79-4b53-972d-4743ae2b52ed',
    Id: 126,
  },
  {
    Name: 'Black Russian Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '87201e5b-3dfb-49ee-8430-47e39111b785',
    Id: 167,
  },
  {
    Name: 'Canadian Eskimo/Inuit',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '301eb41c-6d92-4aad-8e09-49f314887d2c',
    Id: 32,
  },
  {
    Name: 'Tervuren Belgian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a4350d41-2668-4a99-b87c-4a130ce827e2',
    Id: 163,
  },
  {
    Name: 'Havanese',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '392da14c-13f7-45a6-b789-4ad723e9312f',
    Id: 227,
  },
  {
    Name: 'Canary',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'dd1a2141-05b6-43b2-96f1-4b87c65c82ad',
    Id: 319,
  },
  {
    Name: 'American Bandogge Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '33670211-824f-484c-9098-4cfce020e105',
    Id: 310,
  },
  {
    Name: 'Glen of Imaal Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2cbae918-1715-4c9b-86ab-4d8902559d80',
    Id: 219,
  },
  {
    Name: 'Bavarian Mountain Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2907b676-d413-4525-bddd-50366fe4f062',
    Id: 67,
  },
  {
    Name: 'St. Johns Waterdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'cef47b27-8dd8-476d-9e84-506d6f4a82dc',
    Id: 130,
  },
  {
    Name: 'Northern Inuit',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3e7aeec8-1781-4e0e-9c54-50e48756a8c5',
    Id: 451,
  },
  {
    Name: 'Brussels Griffon (Brabancon)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd6ec30a4-3d8d-48b8-a291-5146c1d2a25f',
    Id: 65,
  },
  {
    Name: 'Pyrenean Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5771b804-7387-47fa-9ef7-5152871908bd',
    Id: 104,
  },
  {
    Name: 'Segugio Italiano',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3b641bb4-76a5-47ff-9cd4-518454157570',
    Id: 100,
  },
  {
    Name: 'Toy Australian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '12dfc9b7-f07a-4adb-8c76-51c35c0db2aa',
    Id: 455,
  },
  {
    Name: 'Dalmatian',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3fbec6eb-b1ac-4da1-a7b9-51e9b2f88e61',
    Id: 200,
  },
  {
    Name: 'Scottish Deerhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8c549bfd-4bd3-4f8d-ac97-52e39d72122c',
    Id: 281,
  },
  {
    Name: 'Schnauzer - Standard',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ee9844a3-783b-4d94-8469-531acd2ddb7e',
    Id: 294,
  },
  {
    Name: 'English Foxhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5325a7a3-0c1c-4f37-86c4-5399eb215dde',
    Id: 205,
  },
  {
    Name: 'Coonhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5d786432-8136-42ae-8887-53dadfe5b1fa',
    Id: 196,
  },
  {
    Name: 'Azawakh Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '03a368d4-2dea-4fe8-883f-54d13db8e013',
    Id: 17,
  },
  {
    Name: 'Dachshund - Standard Long Haired',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '216b4dec-ac44-402b-82e2-558f0236eafa',
    Id: 47,
  },
  {
    Name: 'Australian Cattle Dog/Red Heeler',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b6bd820e-d7cb-4f48-88a1-5596a6b2abdf',
    Id: 418,
  },
  {
    Name: 'Bambino',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '538ba695-68a1-4166-84dc-5737da317ec8',
    Id: 459,
  },
  {
    Name: 'Dutch Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '69a6fe54-de1f-44f5-b39d-575ebd9de8e8',
    Id: 450,
  },
  {
    Name: 'Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e56e29af-61e8-4141-b148-57701f35f94b',
    Id: 246,
  },
  {
    Name: 'Prague Ratter',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '12dd203d-fa34-47c1-8046-57723154a40d',
    Id: 416,
  },
  {
    Name: 'Landseer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '195f62f3-25f0-430b-89ec-57a744371e24',
    Id: 79,
  },
  {
    Name: 'Old English Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '176155a4-21da-47a1-880d-57b20b7cce48',
    Id: 257,
  },
  {
    Name: 'Wirehaired Pointing Griffon',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '65a627a1-9c82-4a14-90b9-587583321d67',
    Id: 308,
  },
  {
    Name: 'Giant Schnauzer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '26eb224e-9cd0-4d22-96f9-589223a6f953',
    Id: 218,
  },
  {
    Name: 'Sarplaninac',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2cc14ce6-8b16-4794-9a25-58b333820dee',
    Id: 439,
  },
  {
    Name: 'Rhodesian Ridgeback',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a2aaddf8-e60c-4e0e-a166-59a54b0ab681',
    Id: 275,
  },
  {
    Name: 'Berger des Pyrenees',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f4667113-ba78-456b-ba71-59fd0819fd9b',
    Id: 317,
  },
  {
    Name: 'Irish Red and White Setter',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4d5c73d1-cfcb-4a3d-8779-5a8de34592cc',
    Id: 101,
  },
  {
    Name: 'Dachshund - Standard Smooth Haired',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6f9abfa0-0ad1-4b70-a0ec-5b7c3b659feb',
    Id: 48,
  },
  {
    Name: 'Flat-Coated Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8be258b9-e730-4012-97c3-5ba245a03860',
    Id: 211,
  },
  {
    Name: 'Australian Cattle Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '53c43aba-cb3b-45b4-9f94-5d9d3c0d0158',
    Id: 152,
  },
  {
    Name: 'Sealyham Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4b10af58-4461-49d8-b139-5e2520c1607b',
    Id: 283,
  },
  {
    Name: 'Aussalier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ade23923-4631-451a-bb9e-5e91f6d36fbd',
    Id: 457,
  },
  {
    Name: 'Ariegeois',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'bc7e927f-ef25-48d5-bcdb-5ed1877afdc6',
    Id: 436,
  },
  {
    Name: 'Jack Russell Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4070f16f-1d36-4e47-a8aa-5f21ca75567f',
    Id: 389,
  },
  {
    Name: 'Thai Ridgeback',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd0bfa442-be47-466c-8ddf-5f5265c2be63',
    Id: 127,
  },
  {
    Name: 'Pembroke Welsh Corgi',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '80a2e17f-147d-41c6-acae-623a7cb9f999',
    Id: 262,
  },
  {
    Name: 'Mountain Cur',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'aea1e244-9946-4d22-aff1-63950880287e',
    Id: 135,
  },
  {
    Name: 'Portuguese Water',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f8a508fb-9533-4876-8100-63ce03f1fd46',
    Id: 270,
  },
  {
    Name: 'Shiba Inu',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b80ff0e8-8a48-4183-8e41-6488870786de',
    Id: 285,
  },
  {
    Name: 'Entlebucher Mountain Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '97c5e101-16dc-4204-b35e-65319a158f8f',
    Id: 54,
  },
  {
    Name: 'Bolognese',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'dd36653f-c60e-4c86-a02a-657516fd7d56',
    Id: 411,
  },
  {
    Name: 'Wetterhoun',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6f3fd560-e32c-42cf-a452-65a53f1321f0',
    Id: 429,
  },
  {
    Name: 'Swedish Elkhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4dfe0cc4-5fbc-4fb0-824b-677f3b7f719d',
    Id: 53,
  },
  {
    Name: 'Spanish Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '512d72fd-3ba9-4305-bd04-6827e5e23826',
    Id: 332,
  },
  {
    Name: 'Chow Chow',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '80f545ac-8b8f-4274-bf5f-68c95a9fb1ac',
    Id: 192,
  },
  {
    Name: 'Toy Manchester Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a51ef5df-4473-4cb1-8b9d-68f92685f3b9',
    Id: 420,
  },
  {
    Name: 'German Pinscher',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b7d2c04a-0184-4a2f-a116-6900434a2bec',
    Id: 213,
  },
  {
    Name: 'Australian Cattle Dog/Blue Heeler',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7463e2ff-2491-4896-aa4f-690eeb0880eb',
    Id: 25,
  },
  {
    Name: 'German/Mittel Spitz',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6644b791-f3c9-4faf-9c64-6a6781b296ff',
    Id: 61,
  },
  {
    Name: 'Dingo/Carolina',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '210b2b65-4d9c-4d73-bfe3-6b7baaa432e9',
    Id: 51,
  },
  {
    Name: 'Labrador Retriever (Black)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8c91f4f1-5d48-4c9a-91df-6bd74ebc3374',
    Id: 131,
  },
  {
    Name: 'Australian Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3470ef52-87f6-4faa-96f6-6be6fde8e6fa',
    Id: 154,
  },
  {
    Name: 'Cesky Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8a4c5c1e-6ad0-401c-9886-6ce60ad9644f',
    Id: 120,
  },
  {
    Name: 'Nova Scotia Duck Tolling Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '11b12908-3bf2-495d-9548-6d30ea38d5b7',
    Id: 256,
  },
  {
    Name: 'Victorian Bulldog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b3f0a804-cbe1-4814-abec-6d47d6978523',
    Id: 30,
  },
  {
    Name: 'Blue Tick Coonhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd3c6dc35-7848-454f-8a3e-6d810c48b8ed',
    Id: 169,
  },
  {
    Name: 'Alpine Dachsbracke',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '390c15f0-fbfb-4804-b903-6dd8bb1c10d2',
    Id: 428,
  },
  {
    Name: 'Anatolian/Karabash Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c978196b-69bb-4d89-ba61-6fe7c449cf8c',
    Id: 14,
  },
  {
    Name: 'Kerry Beagle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'db1928ec-5c47-425d-82e3-70fadae1b524',
    Id: 437,
  },
  {
    Name: 'American Hairless Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ce8ab5a0-6c20-43e7-81ba-711f13bc8ec8',
    Id: 116,
  },
  {
    Name: 'Grand Basset Griffon Vendéen',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '92bdec81-4aba-4702-a3d3-7347fafeaad9',
    Id: 62,
  },
  {
    Name: 'Poodle-Toy',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'eb09b2f6-3f3f-4c36-aee8-73a23ab79f20',
    Id: 92,
  },
  {
    Name: 'Great Dane',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6d059c8e-3d51-440a-9489-750464af22cd',
    Id: 222,
  },
  {
    Name: 'Doxiepoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'da644048-f7ee-46f7-af7a-765e07e26086',
    Id: 465,
  },
  {
    Name: 'Welsh Sheepdog (Welsh Collie)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0b375158-7d1b-4546-ac9f-771af84df905',
    Id: 41,
  },
  {
    Name: 'Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '716f413f-6272-4d5a-913a-784189b2187b',
    Id: 115,
  },
  {
    Name: 'Fila Brasileiro/Brazillian Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5a09c131-99fd-45bf-a9e3-78983d7b9bc5',
    Id: 57,
  },
  {
    Name: 'Rafeiro do Alentejo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '58dfb09e-1c49-4534-90c1-79c2d8dbbb70',
    Id: 98,
  },
  {
    Name: 'Rat Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5ddd74c0-4df3-4c99-b8c0-79d9959ed656',
    Id: 273,
  },
  {
    Name: 'English Toy Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e12bd584-b778-4254-bfe3-7a1c3fd133ca',
    Id: 121,
  },
  {
    Name: 'Havana Silk',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a72312e1-b265-4fad-8a01-7a339487868f',
    Id: 449,
  },
  {
    Name: 'Tibetan Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e24432a9-29e9-45ea-b294-7b426f0741df',
    Id: 297,
  },
  {
    Name: 'Neapolitan Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c8a1a8ba-63ad-48df-a34c-7b5400d43791',
    Id: 251,
  },
  {
    Name: 'Schapendoes',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1e6bb27e-2646-4eaa-907c-7d12c9d8c49f',
    Id: 99,
  },
  {
    Name: 'English Cocker Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6e7724c5-86a0-4ec5-941b-7fdd6d393e33',
    Id: 204,
  },
  {
    Name: 'Soft Coated Wheaten Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'bc4eaedc-3fcc-4d0e-a5c7-812696c3d592',
    Id: 291,
  },
  {
    Name: 'Australian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c0501ad3-6397-4ebb-a743-81394e90d8cd',
    Id: 153,
  },
  {
    Name: 'Shih Tzu',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b83182c0-6210-4d26-86e1-8141cf030bc2',
    Id: 286,
  },
  {
    Name: 'American Pitbull Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '45be8ee2-108e-4ff9-a533-81ccddb04417',
    Id: 148,
  },
  {
    Name: 'Cocker Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '455edb93-793b-4fe8-b10e-8296566e643b',
    Id: 194,
  },
  {
    Name: 'Inuit',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0e181f70-7f72-4ab2-94d1-83afbf3a8a19',
    Id: 71,
  },
  {
    Name: 'American Blue Gascon Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd18f40e3-352d-46da-8fdb-83dc3debb425',
    Id: 312,
  },
  {
    Name: 'Lowchen',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8fae8471-a344-4310-9f3f-8439e133e0f0',
    Id: 243,
  },
  {
    Name: 'Anglo Francais',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '85485205-8e3d-47a4-a901-843e82b02cb0',
    Id: 430,
  },
  {
    Name: 'Clumber Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4b008f88-b3c6-4c35-ad22-846ed131b9e8',
    Id: 193,
  },
  {
    Name: 'Czechoslovakian Wolfdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '74e3fa8a-2246-4f40-876d-8772a794b741',
    Id: 43,
  },
  {
    Name: 'English Setter',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f7a4e5d4-8200-46a7-b3a0-89ee1c492630',
    Id: 206,
  },
  {
    Name: 'Mixed breed Small (up to 20lbs when full grown)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '54c9e286-f2ff-4b9d-97ef-8a1388a9d66f',
    Id: 444,
  },
  {
    Name: 'Cockapoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2c25ca27-a515-43e4-89a5-8a7c9f12ef75',
    Id: 395,
  },
  {
    Name: "Cirneco dell'Etna",
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '08179699-9076-4e3b-b003-8ad4925b4759',
    Id: 38,
  },
  {
    Name: 'American Black and Tan Coonhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3c9d6ee0-b1e6-46aa-89cc-8c72961a5824',
    Id: 311,
  },
  {
    Name: 'Karelian Bear Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '546dbf2a-9115-4c01-aca8-8ccf7e1800da',
    Id: 405,
  },
  {
    Name: 'Minskin',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '490351ad-78de-4924-ab41-8cfcb1bf5772',
    Id: 471,
  },
  {
    Name: 'Irish Water Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4c9880d2-a028-4331-9a85-8d2b334fa1e7',
    Id: 231,
  },
  {
    Name: 'Bedlington Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c06ab6a2-1d07-4985-a9d3-8d711f5b46e5',
    Id: 160,
  },
  {
    Name: 'Wirehair Vizsla',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5ba38d51-5701-4ac2-a368-8e2d75bd2860',
    Id: 129,
  },
  {
    Name: 'Dachshund - Standard Wire Haired',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'cbda602b-8040-47d8-a82b-8fd25d8decf3',
    Id: 49,
  },
  {
    Name: 'Yorkshire Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ba0c0197-63e5-4eeb-b237-901c8d7085cb',
    Id: 309,
  },
  {
    Name: 'Tosa',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6f2d8541-b1d8-4ef8-97f8-90b7a23c2bc0',
    Id: 128,
  },
  {
    Name: 'Formosan (Taiwanese) Mountain Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '20302d86-f022-4ab2-8cb1-9132e978108f',
    Id: 419,
  },
  {
    Name: 'Balkanski Gonic',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c9cbd62c-8a6b-47f7-82b2-913f8481923e',
    Id: 432,
  },
  {
    Name: 'Nebolish Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '38517b59-6e5f-4a3b-b2f4-91c44afd268a',
    Id: 324,
  },
  {
    Name: 'Boykin Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '764e4178-1a02-439e-86ac-91e55210b074',
    Id: 390,
  },
  {
    Name: 'Blackmouth Cur',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a795899f-a80d-44eb-b217-931fe0613c07',
    Id: 134,
  },
  {
    Name: 'Puli',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5fd2ac41-8af0-4990-90f6-93fea2867716',
    Id: 272,
  },
  {
    Name: 'Border Collie',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '72b6ca52-8267-4271-bd4e-941839bfefd6',
    Id: 170,
  },
  {
    Name: 'Labrador Retriever (Chocolate)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '23bd48f8-d1ec-49f9-a4d8-942387da43d5',
    Id: 132,
  },
  {
    Name: 'Rottweiler',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f9a3adb9-1060-4187-828f-9551ad3da287',
    Id: 276,
  },
  {
    Name: 'Ibizan Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '24526a3c-8034-42bf-bf16-956c351de548',
    Id: 228,
  },
  {
    Name: 'Norwegian Elkhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '082cf7e3-90de-4cfb-b248-9572a8e19103',
    Id: 254,
  },
  {
    Name: 'Japanese Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f2b11c82-16c2-4895-b658-957642faeb90',
    Id: 123,
  },
  {
    Name: 'Keeshond',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3f67ff3e-2052-4f96-be54-957f865bc6a2',
    Id: 235,
  },
  {
    Name: 'Deerhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4dcad552-d04a-4879-9b5a-95badd853a67',
    Id: 50,
  },
  {
    Name: 'Silky Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8d864795-ce97-4fc8-a5ac-96e65f1d8761',
    Id: 288,
  },
  {
    Name: 'Brittany Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd2697497-a2a5-45cc-815c-96f1c089ad3f',
    Id: 108,
  },
  {
    Name: 'Bullmastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f5dd9a4a-de96-4b3f-afc5-9833f107603f',
    Id: 181,
  },
  {
    Name: 'Cardigan Welsh Corgi',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c4f7c2c6-15a8-4abb-aa7d-9948b3f410ad',
    Id: 185,
  },
  {
    Name: 'American Bully',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f268c71f-14a5-4263-aa25-99547704bb92',
    Id: 456,
  },
  {
    Name: 'Mountain Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '561fab8e-f1e1-4306-b97c-995496ff455f',
    Id: 124,
  },
  {
    Name: 'Biewer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '385034ca-9b07-4325-b9bc-9a1e91c37ea7',
    Id: 423,
  },
  {
    Name: 'Belgian Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '78b52b82-2222-4806-9311-9b749bd134d2',
    Id: 316,
  },
  {
    Name: 'Grand Bleu De Gascoigne',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '66f82019-6e1b-47ad-ac1c-9c82e1ac90c7',
    Id: 63,
  },
  {
    Name: 'Australian Labradoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '87179eb9-bd6c-43dc-a36e-9ca04dfd1dd8',
    Id: 458,
  },
  {
    Name: 'Saint Bernard',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f146d108-42e1-4ee6-b670-9cb50a8803fc',
    Id: 277,
  },
  {
    Name: 'Springer Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7836c570-fbec-43c2-9735-9d8f48c2d464',
    Id: 111,
  },
  {
    Name: 'Norwegian/Norsk Lundehund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2847af83-c871-455f-a3a7-9d941a36cadf',
    Id: 87,
  },
  {
    Name: 'English Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '25c507b7-85ec-4cda-9841-9e9fed85800d',
    Id: 139,
  },
  {
    Name: 'Drever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '86d16b49-b72a-4c50-b4a6-9ebb979abc71',
    Id: 52,
  },
  {
    Name: 'Finnish Spitz',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fefa162f-2825-460e-a27c-a001739029e7',
    Id: 210,
  },
  {
    Name: 'Japanese Chin (Spaniel)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6e43091e-adfc-4476-b407-a05794c57a03',
    Id: 72,
  },
  {
    Name: 'German Longhaired Pointer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7f0497d2-a7d8-4bc0-9c26-a1654ad47e72',
    Id: 60,
  },
  {
    Name: 'Long Haired Chihuahua',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e026e194-b873-4f88-9bab-a17e0861915e',
    Id: 36,
  },
  {
    Name: 'Finnish Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6b93b7d9-ebd5-475f-86b8-a1e10e8545a4',
    Id: 434,
  },
  {
    Name: 'German Spitz',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '30713674-4426-4f32-b153-a1e454ca7cce',
    Id: 216,
  },
  {
    Name: 'Hovawart',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '46fd7121-3fa3-47d0-9d7b-a28a85eac121',
    Id: 69,
  },
  {
    Name: 'Plott',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd950cea0-e965-4f6d-b7f5-a2977a8241aa',
    Id: 265,
  },
  {
    Name: 'Patterdale/Fell Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a09bc778-6733-441a-9117-a4512dbd5bcc',
    Id: 125,
  },
  {
    Name: 'Toy Fox Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1ddbb576-302f-4e7a-9781-a4e13e8a5834',
    Id: 300,
  },
  {
    Name: 'Parson Russell Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'eb4e63e1-14fc-4735-b47a-a5ecd3cf1140',
    Id: 260,
  },
  {
    Name: 'Bull Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'da84d8a0-ebd1-46c6-a852-a6d8c81bab6c',
    Id: 179,
  },
  {
    Name: 'Argentine Dogo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5a551a4b-b43c-4c51-9a58-a858ff2115cc',
    Id: 408,
  },
  {
    Name: 'Lakeland Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '812e01dd-80fa-4c32-a719-a98d5ea75911',
    Id: 240,
  },
  {
    Name: 'Samoyed',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'dede39ef-66dc-4ec2-b4f0-aa85942415e7',
    Id: 279,
  },
  {
    Name: 'Portuguese Podengo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f13d2245-b377-450f-8670-aaaa9805ab7e',
    Id: 407,
  },
  {
    Name: 'American Bulldog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1a2c9e4e-6daf-445f-b6f3-accd136e8c17',
    Id: 313,
  },
  {
    Name: 'Miniature Wire Haired Dachshund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fc2d4888-c9c0-48c1-bd7f-ad8da243fcc8',
    Id: 46,
  },
  {
    Name: 'Russian Bolonka',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '66644ae3-ac9d-4323-8cf1-ade1c84d09c5',
    Id: 140,
  },
  {
    Name: 'West Highland White Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2c9f6945-60e2-4f60-afe3-ae0cc240c207',
    Id: 305,
  },
  {
    Name: 'American Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'bbb98d7b-3313-4230-9770-ae9549cb1f89',
    Id: 315,
  },
  {
    Name: 'Labrador Retriever (Yellow)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c98bab2d-6b82-4912-8fab-af3eaa86787c',
    Id: 133,
  },
  {
    Name: 'Mixed breed (Unknown size)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6f0dbdc2-d547-4e74-a0dc-b0a1a841fcde',
    Id: 336,
  },
  {
    Name: 'Elf',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6c860d3f-80a2-423d-9d41-b0b9774ce6f9',
    Id: 466,
  },
  {
    Name: 'Ganaraskan',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1d638d54-cce6-495d-a956-b11453bac088',
    Id: 59,
  },
  {
    Name: 'Siberian Husky',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '00e7b183-f5d8-421c-a9f0-b1c5aeec4454',
    Id: 287,
  },
  {
    Name: 'Canaan Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '549e46c0-65d8-4260-8462-b2a205afd8fb',
    Id: 31,
  },
  {
    Name: 'Vizsla',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0146f3c9-fbff-4a34-9b67-b3137ea22a66',
    Id: 301,
  },
  {
    Name: 'Korean Jindo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ec3795b9-e0c7-4e2e-abcb-b3a8d055c954',
    Id: 433,
  },
  {
    Name: 'Pyrenees Braque Francais',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'aa31d5f1-7cda-432c-8fb1-b3dcd238eb78',
    Id: 29,
  },
  {
    Name: 'Yorkiepoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1df2b565-c041-4c2f-acac-b3e75d24420e',
    Id: 398,
  },
  {
    Name: 'Cavalier King Charles Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '272f9d3a-cdf5-40c2-b0a8-b463d08cb0b4',
    Id: 187,
  },
  {
    Name: 'Aidi',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'eefe1858-ca28-4826-b2f6-b483e3a9535c',
    Id: 435,
  },
  {
    Name: 'Collie - Smooth',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '26ed0e95-8c33-48ff-b763-b4f1111080cd',
    Id: 40,
  },
  {
    Name: 'Bouvier des Flandres',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd2c346df-d750-4e72-a769-b5680a11f6da',
    Id: 174,
  },
  {
    Name: 'Pyrenean Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2ec4032a-70d5-4f2f-b542-b66bf6edc2e3',
    Id: 97,
  },
  {
    Name: 'American Water Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'aa8e5301-193b-43c2-adf7-b7a2cd1c21b6',
    Id: 150,
  },
  {
    Name: 'Maltipoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2bd408e6-b2f4-4510-82ae-b7ab9bfa8c2b',
    Id: 393,
  },
  {
    Name: 'Welsh Springer Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '40fe6bb0-6b42-47c2-ad36-b7cbfd10823f',
    Id: 303,
  },
  {
    Name: 'Manchester Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '456b5f4d-c14d-4d4e-8495-b8e762ec6506',
    Id: 245,
  },
  {
    Name: 'Snoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1ad8101e-8dbd-478c-a715-b936cfabaee6',
    Id: 333,
  },
  {
    Name: 'Labradoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2a973cd2-8055-41ce-8d46-b94271869533',
    Id: 323,
  },
  {
    Name: 'Texas Blue Lacey',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2a232f0a-8c19-48c6-9947-b948e101608b',
    Id: 406,
  },
  {
    Name: 'Swedish Lapphund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4b39fdcf-144e-4d1a-a7c7-b96b88dff0ee',
    Id: 114,
  },
  {
    Name: 'Boston Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'bfa47a3c-5296-4f41-8a24-b9790fb87745',
    Id: 173,
  },
  {
    Name: 'Bloodhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '922f7288-523d-4e4f-9d0d-b9883756f6a9',
    Id: 168,
  },
  {
    Name: 'Lhasa Apso',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '91fe4cee-5f50-4411-8298-ba506d781dbf',
    Id: 242,
  },
  {
    Name: 'Pekingese',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5313de49-a069-4566-ba01-baf7ec0160ff',
    Id: 261,
  },
  {
    Name: 'Newfoundland',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fb5c3efc-2edc-4746-93af-bb08d4bae3b2',
    Id: 252,
  },
  {
    Name: 'Laekenois Belgian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f35f5566-ebda-409c-aa25-bb26ffd6c99e',
    Id: 20,
  },
  {
    Name: 'Shiloh Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'cc0f1979-4366-4451-9822-bb4d18992c53',
    Id: 335,
  },
  {
    Name: 'Appenzeller Sennenhunde',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '67067ca8-de2f-4a2c-b315-bc93ac99b292',
    Id: 15,
  },
  {
    Name: 'Lancashire Heeler',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f49c0e87-8d74-4573-a075-bca47da4a195',
    Id: 78,
  },
  {
    Name: 'Alaskan Malamute',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'df7d837c-f12d-445a-9891-bcaefefcf11e',
    Id: 145,
  },
  {
    Name: 'Norwich Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0254f06f-c3e6-40ef-86f8-bd5c6880bca4',
    Id: 255,
  },
  {
    Name: 'Miniature Labradoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '42fc7804-dd4e-40a0-9081-bd7daca6248f',
    Id: 470,
  },
  {
    Name: 'Pumi',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd048441c-8160-4940-8467-bd851b2138e0',
    Id: 96,
  },
  {
    Name: 'Mi-Ki',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2fa57e40-a2fd-40ae-9b5d-be067ea27d1a',
    Id: 404,
  },
  {
    Name: 'Irish Setter',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9f6671af-4cd9-45d6-a65f-be541ee53425',
    Id: 229,
  },
  {
    Name: 'French Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2ee2b6aa-0081-46a0-905c-be69e222ddcd',
    Id: 109,
  },
  {
    Name: 'Swedish Vallhund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2359fc0c-6981-418a-af38-c07bfe2469ee',
    Id: 296,
  },
  {
    Name: 'Portuguese Pointer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f3628bfb-4435-41f4-8e93-c08b4906d0c3',
    Id: 93,
  },
  {
    Name: 'King Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2412415b-5430-4f39-bba8-c0c27088e482',
    Id: 482,
  },
  {
    Name: 'Pomsky',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f56888d9-3d3f-4776-b929-c0ff435573d9',
    Id: 475,
  },
  {
    Name: 'Whippet',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c9ee77f3-d3c2-45c5-812e-c3086461584f',
    Id: 306,
  },
  {
    Name: 'Brittany',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b77e3e5f-2bd7-493b-8125-c481c7945670',
    Id: 177,
  },
  {
    Name: 'Chinook',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a990ecee-2420-4788-8b22-c56f53597715',
    Id: 415,
  },
  {
    Name: 'Australian Stumpy Tail Cattle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '36f0d793-f0ce-4e22-bdab-c5d0d529e6e8',
    Id: 33,
  },
  {
    Name: 'Greyhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '57ec82b1-6095-4450-b5f7-c5f752b894d7',
    Id: 225,
  },
  {
    Name: 'Chihuahua',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8643d9e3-6f26-4b62-8d18-c65d87495ddd',
    Id: 189,
  },
  {
    Name: 'Shihpoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c096b6ea-3ece-4a30-89cc-c6fee7042b6d',
    Id: 479,
  },
  {
    Name: 'Pomeranian',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'babb421b-d8ce-4c0c-a091-c80a8674866e',
    Id: 268,
  },
  {
    Name: 'Frenchton',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'bb56878f-cea1-4140-bf13-ca050c88c81a',
    Id: 467,
  },
  {
    Name: 'Morkie',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9173bbc9-d919-43a6-b15e-ca957192e852',
    Id: 472,
  },
  {
    Name: 'Otterhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd758c2b1-7813-48d3-a955-ca9ac04e8b9d',
    Id: 258,
  },
  {
    Name: 'Norwegian Buhund',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7831ea4e-464f-4fe0-bdba-cb0d1d2b2304',
    Id: 86,
  },
  {
    Name: 'Berger Picard/Picardy Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'cd38f4ea-1591-421f-b389-cbcc8e435a58',
    Id: 24,
  },
  {
    Name: 'Kai Ken',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '554eadaf-9bda-4ae6-bc5a-cd6aaf91b38b',
    Id: 74,
  },
  {
    Name: 'Basset Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '48f10a94-023b-4feb-ac7b-cde4b088be9b',
    Id: 156,
  },
  {
    Name: 'Shikoku',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1430929d-3b7c-45cb-b2c2-ce257e568214',
    Id: 413,
  },
  {
    Name: 'Small Munsterlander',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6fd17852-d1ab-417d-8f57-ce2c216a9daa',
    Id: 84,
  },
  {
    Name: 'Catahoula Cur/Leopard Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '6e99d58b-a124-4ce4-9da9-ce70001616c6',
    Id: 138,
  },
  {
    Name: 'Kuvasz',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2464f0c5-a884-4864-8b14-cf369b83f0a6',
    Id: 238,
  },
  {
    Name: 'Papillon',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '391af4c8-8010-48f6-8dd1-d02f26bf68b8',
    Id: 259,
  },
  {
    Name: 'North American Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1fb1471f-aeab-4549-b889-d07c20e264b7',
    Id: 473,
  },
  {
    Name: 'Sussex Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1715fc41-b6a8-48f9-9f98-d1586e09a560',
    Id: 295,
  },
  {
    Name: 'Border Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'a16b7606-0b78-466c-8d51-d19e43c599e4',
    Id: 171,
  },
  {
    Name: 'Akita',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b95b19f3-4f33-4e45-b41a-d1bea6c79591',
    Id: 144,
  },
  {
    Name: 'Dandie Dinmont Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '703db446-83dc-4b81-80fc-d1c15cd5714a',
    Id: 201,
  },
  {
    Name: 'Dogue de Bordeaux',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '583f89d5-6798-423c-8afb-d3d16b9fba65',
    Id: 203,
  },
  {
    Name: 'Poochon',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '67d3e491-b10f-4071-be79-d5c8389d7b97',
    Id: 476,
  },
  {
    Name: 'Bernese Mountain Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5b3106da-907a-4fc8-ba52-d689bcd2cb59',
    Id: 164,
  },
  {
    Name: 'Bracco Italiano',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f3a57032-4e87-46fe-ab1d-d6b3e0bf1e4b',
    Id: 27,
  },
  {
    Name: 'Black and Tan Coonhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '90a8fb31-cf5a-439d-89ae-d755f3150355',
    Id: 166,
  },
  {
    Name: 'Komondor',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd02215cb-64ae-4f67-922c-d8258ef8404d',
    Id: 237,
  },
  {
    Name: 'Leonberger',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ed68ffcb-a37b-4839-b1e7-d9b86d182c2f',
    Id: 241,
  },
  {
    Name: 'American Cocker Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9ae4c60c-19cc-44e2-9c47-dae07f269a4e',
    Id: 314,
  },
  {
    Name: 'Bull Terrier - Standard',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0c4ec625-5697-4e5f-a060-dbdb96dc31db',
    Id: 119,
  },
  {
    Name: 'Beauceron',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1bdbc417-ab1f-4c35-a0e4-dc0baecbe18a',
    Id: 159,
  },
  {
    Name: 'Miniature Bull Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2a985a16-f303-490d-801c-dc6cfb9f656d',
    Id: 248,
  },
  {
    Name: 'Poodle-Standard',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b903aeb9-8ee4-4146-b334-dcffcc240b85',
    Id: 269,
  },
  {
    Name: 'Cane Corso',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7f97fef9-937b-448f-a7c3-dd3d73192cdd',
    Id: 184,
  },
  {
    Name: 'Cobber Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '418858a9-d60d-4afc-87bf-de6b0f821637',
    Id: 452,
  },
  {
    Name: 'Mexican Hairless',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c3c21c91-429a-43ea-8697-e052120f1ddd',
    Id: 403,
  },
  {
    Name: 'Miniature Goldendoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '243f1c2d-ec98-4bdb-9911-e101514f4842',
    Id: 469,
  },
  {
    Name: 'English Cream Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '04b44e31-3acd-4e32-a9c4-e1c1d1b0b45c',
    Id: 481,
  },
  {
    Name: 'Central Asian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '10bbc400-d54d-4bb1-998d-e233112ac02f',
    Id: 35,
  },
  {
    Name: 'Kerry Blue Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9001c199-83f2-4d83-ab42-e292cc1df30c',
    Id: 236,
  },
  {
    Name: 'English Toy Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '63361bf2-344d-46ec-87da-e3f1838fdfb6',
    Id: 208,
  },
  {
    Name: 'Golden Retriever',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3f2377bb-6e59-44b1-a079-e41b9fdcb58f',
    Id: 220,
  },
  {
    Name: 'Weimaraner',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'dbdb572d-0695-47dd-afe9-e4b8f462f943',
    Id: 302,
  },
  {
    Name: 'Italian Bulldogge',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '0cbb416d-7022-4768-8b9f-e4d2586cb09b',
    Id: 322,
  },
  {
    Name: 'Norrbottenspets',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8adc5abe-8831-4fc6-989d-e522e6a0b675',
    Id: 85,
  },
  {
    Name: 'Mudi',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3461fada-db60-4ba2-9943-e7f7ee39b026',
    Id: 83,
  },
  {
    Name: 'Malinois Belgian Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7af53c89-32f2-48a8-8afb-e803ccb52cbc',
    Id: 21,
  },
  {
    Name: 'Puggle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '4c7417f0-942b-4af7-9b37-e838168b96c4',
    Id: 397,
  },
  {
    Name: 'Redbone Coonhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '11c75332-ba44-4a9a-becc-e8400cc5b92b',
    Id: 274,
  },
  {
    Name: 'Maltese',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '757e17f9-a9cc-4faf-bf8e-e893c1b3700e',
    Id: 244,
  },
  {
    Name: 'Airedale Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7b41006f-0341-4e30-b509-e8d527fe3e27',
    Id: 143,
  },
  {
    Name: 'Italian Greyhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7182267d-7a72-4049-aae6-e94a282690c1',
    Id: 233,
  },
  {
    Name: 'Barbet',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3e64980f-eaf8-4395-b212-eb06b650139a',
    Id: 18,
  },
  {
    Name: 'Berger Blanc Suisse',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'd7b93ec1-3e54-468d-9d3d-ebc437dd77ec',
    Id: 486,
  },
  {
    Name: 'Dutch Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c3888ef3-c3c3-45b9-9a98-ec0db8acc181',
    Id: 102,
  },
  {
    Name: 'Staffordshire Bull Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c5bdbae7-496e-454b-afb3-ed44b359a35e',
    Id: 293,
  },
  {
    Name: 'Large Munsterlander',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ebec786f-5894-4320-a3f5-ed8d7b24e8a8',
    Id: 80,
  },
  {
    Name: 'French Bulldog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'def7505c-5830-494a-b2a3-ee258b6d8162',
    Id: 212,
  },
  {
    Name: 'Pyrenean Mountain Dog (Great Pyrenees)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'f64ae821-5b5a-44e6-9250-ef45fc9be494',
    Id: 223,
  },
  {
    Name: 'Terripoo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'ddb0b786-ace4-404c-9990-ef85428c3f89',
    Id: 396,
  },
  {
    Name: "Braque d'Auvergne",
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '21bf792e-2bd5-4385-b9a6-f07596260c41',
    Id: 462,
  },
  {
    Name: 'Blue Picardy Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '033c1f7c-c3d2-47aa-aafd-f09d8c4e90b5',
    Id: 107,
  },
  {
    Name: 'American Eskimo',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '7c4932b6-4808-48f3-90ac-f10bbb5445a6',
    Id: 146,
  },
  {
    Name: 'Greater Swiss Mountain Dog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '2f4281fe-c4eb-4185-b9a4-f275d825e601',
    Id: 224,
  },
  {
    Name: 'German Shepherd',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c891ce38-0293-4a5b-9088-f3098eb8c2d6',
    Id: 214,
  },
  {
    Name: 'Old English Mastiff',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '1218d152-695c-4533-b605-f4bb274bf62d',
    Id: 325,
  },
  {
    Name: 'South Russian Owtcharka',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '93ad131c-d48d-4934-ac4e-f6cfda2f2d7c',
    Id: 443,
  },
  {
    Name: 'Boxer',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c389fb09-75c0-4e1f-be99-f6fd4fe6a6e7',
    Id: 175,
  },
  {
    Name: 'Mixed breed Giant (more than 90lbs when full grown)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '5eefa6a7-417d-46ff-8858-f74c666a1e6d',
    Id: 447,
  },
  {
    Name: 'Borzoi/Russian Wolfhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '618df626-7de4-4e0a-900d-f7f18f2e2a5d',
    Id: 26,
  },
  {
    Name: 'Dunker/Norwegian Hound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c99ad114-4707-40f2-bcc6-f9159f382aec',
    Id: 68,
  },
  {
    Name: 'Shetland Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '8ea2102b-6cdd-49fe-b08b-f97acab4c3f3',
    Id: 284,
  },
  {
    Name: 'Perro de Presa Canario',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b7eaa1d1-a910-4b1d-8c24-f9809923ad11',
    Id: 328,
  },
  {
    Name: 'Irish Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e3b1c1c4-95ce-4c89-a3f1-fa33eee6ee4f',
    Id: 230,
  },
  {
    Name: 'Fox Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '3d8c7279-f66e-4f2b-8084-fad045ad6794',
    Id: 122,
  },
  {
    Name: 'Cairn Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '9a8d29e7-01fd-4dd8-805c-fb21d324940e',
    Id: 182,
  },
  {
    Name: 'Stabyhoun (Stabij)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '600b8624-b15b-4e08-99c7-fb72e6bd7749',
    Id: 113,
  },
  {
    Name: 'English Springer Spaniel',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '20e8217c-ef97-443b-b912-fb8afae5c0d3',
    Id: 207,
  },
  {
    Name: 'American English Coonhound',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'c3cd9407-bdeb-47bd-bef3-fc43d142c0ff',
    Id: 42,
  },
  {
    Name: 'Mixed breed Large (55 – 90lbs when full grown)',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'e6471711-71d8-4998-89ce-fc6b4ac5cf73',
    Id: 446,
  },
  {
    Name: 'Scottish Terrier',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'b95bd36e-e871-4bc0-9ab4-fccf4561a118',
    Id: 282,
  },
  {
    Name: 'Gascogne Braque Francais',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: 'fff17274-426a-4e4e-adc0-fd387689dc36',
    Id: 28,
  },
  {
    Name: 'Belgian Sheepdog',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '93ce151e-58b9-4ee0-b930-fd5cfdb17fa9',
    Id: 162,
  },
  {
    Name: 'Schnoodle',
    SpeciesId: 1,
    Active: true,
    PetCharacteristicId: '789e521b-d571-4bef-b8f3-fdce15bd5f00',
    Id: 394,
  },
  {
    Name: 'Havana Brown',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '3e759d8f-1314-44d7-86c8-0607944956d8',
    Id: 361,
  },
  {
    Name: 'Anatolian',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'c40e0090-b802-4fa4-9a48-0a84f20bcc94',
    Id: 342,
  },
  {
    Name: 'Norwegian Forest',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '99f704d1-811b-48ad-8a38-0aa6dcf24801',
    Id: 370,
  },
  {
    Name: 'Siamese',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '61b41b52-423f-405a-9abb-0e93a6bdef8b',
    Id: 378,
  },
  {
    Name: 'Himalayan',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'eb39f8df-ab06-4ba8-a196-1456802e1d53',
    Id: 362,
  },
  {
    Name: 'Domestic Longhair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '1d7f5081-fa17-4712-b86a-1776b878f66f',
    Id: 357,
  },
  {
    Name: 'Javanese',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '2e17e3d6-f869-41ed-80a2-17ddac269547',
    Id: 364,
  },
  {
    Name: 'Balinese',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'e684b1e1-356c-474d-9435-191a6cb9cc0e',
    Id: 343,
  },
  {
    Name: 'Domestic Shorthair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'de863427-5c74-4ddd-92f0-19ef265dd620',
    Id: 355,
  },
  {
    Name: 'Savannah',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '13d549f1-24f4-450b-9181-1d70a8839e1f',
    Id: 9,
  },
  {
    Name: 'Exotic Shorthair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '3d98c941-d3c6-4107-ab5c-22e38f15d6e3',
    Id: 360,
  },
  {
    Name: 'Russian Blue',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '23d9acae-5a5e-4b1d-8fd4-2667af0578f7',
    Id: 375,
  },
  {
    Name: 'Manx',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '443d0df1-fd00-40e0-8b98-28846edc2b84',
    Id: 367,
  },
  {
    Name: 'American Shorthair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '7ec98c28-1781-4b1f-aea0-2aaa5fb2145a',
    Id: 340,
  },
  {
    Name: 'Pixiebob',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '0704f7a3-2a24-47ff-9837-31e866514d1b',
    Id: 8,
  },
  {
    Name: 'Burmese',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'dba28a5b-6377-4dae-8413-34db2e993c4a',
    Id: 348,
  },
  {
    Name: 'Chartreux',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '4ae02655-c54e-4e09-83fc-37112246f914',
    Id: 350,
  },
  {
    Name: 'Thai',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '643d659b-2d16-4e1e-8009-3aafa17a0ca0',
    Id: 11,
  },
  {
    Name: 'Chantilly/Tiffany',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '89011f4a-dc9a-40d0-9e7c-3b061adf34dc',
    Id: 137,
  },
  {
    Name: 'Sphynx',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '80d09a02-5db7-4803-ab50-3d8f02a20052',
    Id: 383,
  },
  {
    Name: 'Lykoi',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '34e60928-9924-48f2-a303-3fa512272483',
    Id: 453,
  },
  {
    Name: 'Tonkinese',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '830d76f2-0f3a-4862-b11f-438dc53cfb10',
    Id: 385,
  },
  {
    Name: 'British Shorthair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '65826868-628c-47e6-af5e-47cf95f6f9e1',
    Id: 347,
  },
  {
    Name: 'Bombay',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '58f7556d-6003-4735-8e7b-4a3f94837b74',
    Id: 346,
  },
  {
    Name: 'Ojos Azules',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '0216adbf-95fb-41b7-9cba-56bf539287a5',
    Id: 6,
  },
  {
    Name: 'Peterbald',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '2c46188f-747f-4dc0-9105-580dd6d71d5b',
    Id: 7,
  },
  {
    Name: 'Egyptian Mau',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '498eeb90-0aa8-4cdc-b453-5ca1084927f8',
    Id: 358,
  },
  {
    Name: 'Maine Coon',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '7947caa9-0b6f-47e4-a03a-6378b2a9d2c2',
    Id: 366,
  },
  {
    Name: 'Korat',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '243cfd79-a6a9-48dd-a229-64ec1814ae67',
    Id: 365,
  },
  {
    Name: 'European Burmese',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '74178438-e0f2-49f7-bb18-69ec9772d002',
    Id: 359,
  },
  {
    Name: 'British Longhair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '00b6fa30-aa88-4642-a205-6a0a857873d9',
    Id: 1,
  },
  {
    Name: 'Ragdoll',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'ff929b3c-8ac3-45d6-9367-6a958fa59522',
    Id: 374,
  },
  {
    Name: 'Scottish Fold',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'fba42fef-366a-4ffb-b075-700ff9d06e57',
    Id: 376,
  },
  {
    Name: 'Bengal',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'aff317af-2879-4e66-b3fd-72d2b402b4e0',
    Id: 344,
  },
  {
    Name: 'Selkirk Rex',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'f49730ea-e11c-46df-8439-7455aea45b71',
    Id: 377,
  },
  {
    Name: 'Domestic Mediumhair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '1aa1de24-c149-40a0-a509-7833c0e75e47',
    Id: 356,
  },
  {
    Name: 'Chausie',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '38458e14-efc9-401b-870a-84234d643548',
    Id: 2,
  },
  {
    Name: 'Ragamuffin',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '2f81d9c8-1875-42aa-89fb-85389d9934f0',
    Id: 477,
  },
  {
    Name: 'Colorpoint Shorthair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '934863b4-4afe-4d4d-984e-88479aeb1e58',
    Id: 351,
  },
  {
    Name: 'Singapura',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'b4a70cc8-6ed1-4acf-882c-8cc0e03db3cf',
    Id: 380,
  },
  {
    Name: 'Munchkin',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '5fd35487-217b-4720-b2c7-8dfe511c2a25',
    Id: 368,
  },
  {
    Name: 'Cymric',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'c692d42c-0641-43ea-80dd-951236d65f68',
    Id: 353,
  },
  {
    Name: 'Nebelung',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '934f8b94-f4b1-44c6-aa3b-98093f5ae1bf',
    Id: 369,
  },
  {
    Name: 'Burmilla',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'c5e85f7c-f384-4593-974d-9b5dd919a378',
    Id: 463,
  },
  {
    Name: 'Japanese Bobtail',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '0c663765-87a3-4b33-a02d-9eb5b4116d02',
    Id: 363,
  },
  {
    Name: 'California Spangled',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '26809d10-4e33-4aa2-8ff2-a1359a96647d',
    Id: 349,
  },
  {
    Name: 'Donskoy',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '285def98-69b4-4b50-9fce-a3deee1ad6ec',
    Id: 3,
  },
  {
    Name: 'Exotic Longhair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '6e358b27-8943-40e0-a656-a693a4799d60',
    Id: 4,
  },
  {
    Name: 'Devon Rex',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '8b7cd57c-3613-46e2-8300-abc7c887c930',
    Id: 354,
  },
  {
    Name: 'LaPerm',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '3f790e70-2ed5-4f04-b7c4-b6032fb57a58',
    Id: 5,
  },
  {
    Name: 'Birman',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'f45d937a-2b55-490a-a20c-b6709efbb742',
    Id: 345,
  },
  {
    Name: 'Somali',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '2d3e3113-89cd-475a-a7a4-baddf3400a54',
    Id: 382,
  },
  {
    Name: 'American Wirehair',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'ab4b043a-f3b8-407b-9366-c1332ee58144',
    Id: 341,
  },
  {
    Name: 'Tiffany',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'fefdc02a-7739-4eeb-8194-c3cd84701040',
    Id: 384,
  },
  {
    Name: 'Ocicat',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '1df00b89-6f2a-4016-bdca-c3dd35ff3e38',
    Id: 371,
  },
  {
    Name: 'Siberian',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'f4246616-fc5a-4306-b0a8-c50769cb39fb',
    Id: 379,
  },
  {
    Name: 'American Curl',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '118214b7-6535-4380-954e-c54e57d56c03',
    Id: 339,
  },
  {
    Name: 'Abyssinian',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '3f3bfde7-2de7-49e5-9b6f-c9f24dedd8aa',
    Id: 337,
  },
  {
    Name: 'Turkish Angora',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '8f4b25b7-48ec-43e4-b61d-cc9109104c57',
    Id: 386,
  },
  {
    Name: 'Turkish Van',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '4f1a0890-887c-4aff-af99-cf8b02a2bec3',
    Id: 387,
  },
  {
    Name: 'Toyger',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '452d8640-c740-4001-b5f4-d4fce97b6d1a',
    Id: 12,
  },
  {
    Name: 'Serengeti',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'a27bf523-a214-4fdd-947c-d7460f6eb26c',
    Id: 10,
  },
  {
    Name: 'Snowshoe',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '02f502b2-d7f6-4a1d-a975-d822c2c981e6',
    Id: 381,
  },
  {
    Name: 'Persian',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '4adc6e78-817b-4cfb-8333-eb712d3f61d9',
    Id: 373,
  },
  {
    Name: 'American Bobtail',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '45f4fe3b-38dc-4d64-95c0-ec29ffec2957',
    Id: 338,
  },
  {
    Name: 'Highlander',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '09ca51c5-c1c0-4e8e-8104-edde225c3b7f',
    Id: 468,
  },
  {
    Name: 'York Chocolate',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'f14cc3a8-7dea-47be-af70-f720a6334a8e',
    Id: 388,
  },
  {
    Name: 'Cornish Rex',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'd4e78286-3e00-46e1-b96f-fbdfb4882521',
    Id: 352,
  },
  {
    Name: 'Oriental',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: 'f962d24f-e66a-48e4-be49-fe5235ac1c90',
    Id: 372,
  },
  {
    Name: '<Mixed Breed (Cat)>',
    SpeciesId: 2,
    Active: true,
    PetCharacteristicId: '3a2bc295-9891-43db-9a9c-feaeefab2a84',
    Id: 417,
  },
];

export const trupanionCanineBreeds = apiList
  .filter((breed) => breed.SpeciesId === 1)
  .map((breed) => breed.Name)
  .sort();

export const trupanionFelineBreeds = apiList
  .filter((breed) => breed.SpeciesId === 2)
  .map((breed) => breed.Name)
  .sort();
